/**
 * FriendRequest Component - Displays and handles friend requests
 */

import { useState } from 'react';
import { acceptFriendRequest, declineFriendRequest } from '../services/friendService';
import '../styles/FriendRequest.css';

const FriendRequest = ({ request, currentUser, onRequestHandled }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleAccept = async () => {
    if (isProcessing) return;

    setIsProcessing(true);
    try {
      await acceptFriendRequest(
        currentUser.uid,
        currentUser.displayName,
        currentUser.photoURL,
        request.fromUserId,
        request.fromUserName,
        request.fromUserPhoto
      );

      if (onRequestHandled) {
        onRequestHandled(request.id, 'accepted');
      }
    } catch (error) {
      console.error('Error accepting friend request:', error);
      alert('Failed to accept friend request. Please try again.');
    } finally {
      setIsProcessing(false);
    }
  };

  const handleDecline = async () => {
    if (isProcessing) return;

    setIsProcessing(true);
    try {
      await declineFriendRequest(currentUser.uid, request.fromUserId);

      if (onRequestHandled) {
        onRequestHandled(request.id, 'declined');
      }
    } catch (error) {
      console.error('Error declining friend request:', error);
      alert('Failed to decline friend request. Please try again.');
    } finally {
      setIsProcessing(false);
    }
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '';

    const now = Date.now();
    const diff = now - timestamp;
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 60) {
      return 'Just now';
    } else if (minutes < 60) {
      return `${minutes}m ago`;
    } else if (hours < 24) {
      return `${hours}h ago`;
    } else if (days < 7) {
      return `${days}d ago`;
    } else {
      return new Date(timestamp).toLocaleDateString();
    }
  };

  return (
    <div className="friend-request">
      <div className="friend-request-user">
        {request.fromUserPhoto && (
          <img
            src={request.fromUserPhoto}
            alt={request.fromUserName}
            className="friend-request-avatar"
          />
        )}
        <div className="friend-request-info">
          <h4 className="friend-request-name">{request.fromUserName}</h4>
          <p className="friend-request-time">{formatTime(request.timestamp)}</p>
        </div>
      </div>

      <div className="friend-request-actions">
        <button
          className="friend-request-btn accept-btn"
          onClick={handleAccept}
          disabled={isProcessing}
        >
          {isProcessing ? '...' : '✓ Accept'}
        </button>
        <button
          className="friend-request-btn decline-btn"
          onClick={handleDecline}
          disabled={isProcessing}
        >
          {isProcessing ? '...' : '✕ Decline'}
        </button>
      </div>
    </div>
  );
};

export default FriendRequest;
